/* eslint-disable angular/factory-name */

(function iife() {
	"use strict";

	angular.module("dx.webapp.grade").factory("BlockGrading", BlockGradingService);

	function BlockGradingService(
		dxAngularClassHelper
	) {
		var defaults = {
			blockId: 0,
			annotations: [],
		};

		function instantiateAnnotation(data) {
			return dxAngularClassHelper.newAnnotation(data);
		}

		return function BlockGrading(data) {
			angular.extend(this, defaults, data);

			this.annotations = this.annotations.map(instantiateAnnotation);
		};
	}
}());
